// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import i18n from "./i18n/i18n";

type FixedAlign = boolean | "left" | "right";
export const alignRight: FixedAlign = "right";

type OrderType = "descend" | "ascend" | undefined;
export const orderAscend: OrderType = "ascend";
export const orderDescend: OrderType = "descend";

export const formItemBlockLayout = {
  labelCol: {
    xs: { span: 24 },
    xl: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    xl: { span: 24 }
  }
};
export const dateFormat = "DD/MM/YYYY";

export const dateTimeFormat = "DD/MM/YYYY à HH:mm";

export const authRedirectKey = "authRedirect";

export const NEWS_PRIORITY = [
  {
    value: "1",
    label: "priority_1",
    color: "#0097BD"
  },
  {
    value: "2",
    label: "priority_2",
    color: "#F28A00"
  },
  {
    value: "3",
    label: "priority_3",
    color: " #E50A47"
  },
  {
    value: "4",
    label: "priority_4",
    color: " #FF0000"
  }
];

export const DEFAULT_500_ERROR = {
  responseCode: 500,
  errorMessage: i18n.t("global.error.500"),
  data: undefined,
  ok: false
};

export const LINKS_NUMBER_BY_NEWS_THEME = 3;

export const NEWS_WORKFLOW_STATUS: { [index: string]: any } = {
  SAVED: { label: i18n.t("status_news.saved"), color: "#405faf" },
  VALIDATION: { label: i18n.t("status_news.validation"), color: "#fecb00" },
  REFUSED: { label: i18n.t("status_news.refused"), color: "#e2003c" },
  VALIDATED: { label: i18n.t("status_news.validated"), color: "#a96dcf" },
  PUBLISHED: { label: i18n.t("status_news.published"), color: "#0A6661" },
  WAITINGFORPUBLICATION: {
    label: i18n.t("status_news.waiting_for_publication"),
    color: "#00b2a9"
  }
};

export const NEWS_THEME_STATUS: { [index: string]: any } = {
  PUBLISHED: { label: i18n.t("status_news_theme.published"), color: "#00b2a9" },
  UNPUBLISHED: {
    label: i18n.t("status_news_theme.unpublished"),
    color: "#405faf"
  }
};

export const THEMATIC_DOSSIER_STATUS: { [index: string]: any } = {
  PUBLISHED: {
    label: i18n.t("status_thematic_dossier.published"),
    color: "#00b2a9"
  },
  UNPUBLISHED: {
    label: i18n.t("status_thematic_dossier.unpublished"),
    color: "#405faf"
  }
};

export const FIELD_LENGTH = {
  URL: 500,
  DESCRIPTION: 255,
  NAME: 200,
  TITLE: 2000,
  TEXTAREA: 5000,
  MAIL: 255,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ENTITY_ID: 40
};

export const TYPE_SURVEY = [
  {
    label: "month",
    color: "#E50A47"
  },
  {
    label: "quick",
    color: "#0097BD"
  }
];

export const SURVEY_WORKFLOW_STATUS: { [index: string]: any } = {
  SAVED: { label: i18n.t("status_survey.saved"), color: "#405faf" },
  VALIDATION: { label: i18n.t("status_survey.validation"), color: "#fecb00" },
  REFUSED: { label: i18n.t("status_survey.refused"), color: "#e2003c" },
  VALIDATED: { label: i18n.t("status_survey.validated"), color: "#a96dcf" },
  PUBLISHED: { label: i18n.t("status_survey.published"), color: "#0A6661" },
  WAITINGFORPUBLICATION: {
    label: i18n.t("status_survey.waiting_for_publication"),
    color: "#00b2a9"
  },
  VOTECLOSED: { label: i18n.t("status_survey.vote_closed"), color: "#8C034E" }
};

export const SURVEY_WORKFLOW_RESULTS_STATUS: { [index: string]: any } = {
  LIVE: { label: i18n.t("results_status_survey.live"), color: "#40E0D0" },
  FINAL: { label: i18n.t("results_status_survey.final"), color: "#0092B2" }
};

export const USER_WORKFLOW_STATUS: { [index: string]: any } = {
  INACTIVE: { label: i18n.t("status_user.inactive"), color: "#e2003c" },
  ACTIVE: { label: i18n.t("status_user.active"), color: "#0A6661" }
};

export const NEWS_ARCHIVED = [
  { value: true, label: i18n.t("archived_news.yes") },
  { value: false, label: i18n.t("archived_news.no") },
  { value: null, label: i18n.t("archived_news.all") }
];

export const LAZY_SELECT_PAGE_SIZE = 10;
